import {
  DestroyRef,
  Injectable,
  Injector,
  TemplateRef,
  signal,
} from '@angular/core';

export interface TopBannerSlot {
  template: TemplateRef<unknown>;
  injector: Injector;
}

@Injectable({
  providedIn: 'root',
})
export class TopBannerSlotsService {
  private readonly registeredSlots = signal<TopBannerSlot[]>([]);
  readonly slots = this.registeredSlots.asReadonly();

  addSlot(template: TemplateRef<unknown>, injector: Injector): void {
    const slot: TopBannerSlot = { template, injector };

    this.registeredSlots.update((slots) => [...slots, slot]);
    injector.get(DestroyRef).onDestroy(() => this.removeSlot(slot));
  }

  private removeSlot(slot: TopBannerSlot): void {
    this.registeredSlots.update((slots) =>
      slots.filter((registered) => registered !== slot),
    );
  }
}
